import React, { Fragment } from "react";
import A2PortfolioTechStack from "../Components/A2PortfolioTechStack";
import HeroSection from "./HeroSection";
import ProjectOverview from "./ProjectOverview";
import SprigStackSolution from "./SprigStackSolution";
import HighlightedFeatures from "./HighlightedFeatures";
import MoreFeatures from "./MoreFeatures";
import MobileFriendly from "./MobileFriendly";
import Cta from "./Cta";
import DataSyncs from "./DataSyncs";
import Client from "./Client";

export default function NewA2Portfolio() {
  const slides = [
    {
      title: "Frontend",
      logos: [
        "frontendlogo1.png",
        "frontendlogo5.png",
        "frontendlogo6.png",
        "frontendlogo7.png",
      ],
    },
    {
      title: "Backend",
      logos: ["backendlogo1.png"],
    },
    {
      title: "Database",
      logos: ["database1.png"],
    },
    {
      title: "Payment & API Integration",
      logos: ["stripe.png", "easyPay.png", "mailgun.png"],
    },
  ];
  return (
    <Fragment>
      <HeroSection />
      <A2PortfolioTechStack slides={slides} />
      <ProjectOverview />
      <SprigStackSolution />
      <HighlightedFeatures />
      <MoreFeatures />
      <MobileFriendly />
      <Cta />
      <DataSyncs />
      <Client />
    </Fragment>
  );
}
